import { spUrl } from "utils";
import {
	patch,
	put,
	request,
	save,
} from "utils/proxy";
import { API_TENANT } from "globals/constants";


export const tenant = {
	/**
	 * @param {{tenantId: string, id: string}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	update: (params, body, options) =>
		patch(spUrl(`${API_TENANT}/${params.tenantId}/${params.id}`), body, options),

	/**
	 * @param {{tenantId: string, id: string}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	save: (params, body, options) =>
		save(spUrl(`${API_TENANT}/${params.tenantId}/${params.id}`), body, options),

	/**
	 * @param {{tenantId: string, id: string, path: string}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	saveByPath: (params, body, options) =>
		save(spUrl(`${API_TENANT}/${params.tenantId}/${params.id}/${params.path}`), body, options),

	// toggleAttachmentTypeActive: () => patch(spUrl(`${API_TENANT}/${tenant.tenantId}/${camelToKebabCase(list)}`), modifiedList),

	/**
	 * @param {{tenantId: string}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	updateSubawardCostcap: (params, body, options) =>
		patch(spUrl(`${API_TENANT}/${params.tenantId}/costcap`), body, options),

	/**
	 * @param {{tenantId: string, type: string}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	saveCertificationText: (params, body, options) =>
		put(spUrl(`${API_TENANT}/${params.tenantId}/certification-text/${params.type}`), body, options),

	/**
	 * @param {{tenantId: string}} params
	 * @param {{size: string}} params
	 * @param {{}?} options
	 */
	getTenantProducts: (tenantId, size, options) => request(`/api/v2/tenant/tenant/${tenantId}/product?size=${size}`, options),

	/**
	 * @param {{userId: string}} params
	 * @param {{}?} options
	 */
	getProductUser: (params, options) => request(`/api/v2/tenant/product/user/${params.userId}`, options),
};
